import React from 'react';
import styled from 'styled-components';
const WrapSectionLayoutStyled = styled.section`
	.MuiBox-root {
		display: flex;
		flex: 1;
		flex-direction: column;
	}
`;
const WrapSectionLayout = ({ className, children }) => {
	return (
		<WrapSectionLayoutStyled className={`flex-1 flex flex-col ${className}`}>
			{children}
		</WrapSectionLayoutStyled>
	);
};

export default WrapSectionLayout;